export default __webpack_public_path__ + "static/LexendDeca-VariableFont_wght-4282d793cb1b0cc2aed30c7e9c766fed.ttf";